import { useHistory } from 'react-router-dom';

import {
  Box, Button, Grid
} from '@mui/material';

import { StartPagesContainer } from '../shared/StartPagesContainer';

import { useStyles } from './style';

export const StartPage = () => {
  const classes = useStyles();

  const history = useHistory();

  return (
    <StartPagesContainer>
      <Box className={`loginLayout ${classes.root} ${classes.fullPageHeight}`}>
        <Grid
          container
          alignItems="center"
          rowSpacing={{ xs: 3, sm: 2, md: 4 }}
        >
          <Grid item xs={12}>
            <Box className={classes.gridItem}>
              <Box className={classes.averRegLogoImgWrap}>
                <Box className={classes.averRegLogoImg} component="img" src="./assets/images/Header_Logo.svg" alt="Header_Logo" />
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box className={classes.gridItem}>
              <Button onClick={() => history.push('/login')} variant="contained" color="warning" sx={{ fontSize: 25 }}>Start</Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </StartPagesContainer>
  );
};
